import Axios from 'axios';
var ServiceInterfaceService = (function () {
    function ServiceInterfaceService() {
    }
    ServiceInterfaceService.prototype.serviceList = function (params) {
        return Axios.post("supplierclientapi/api/log", params);
    };
    ServiceInterfaceService.prototype.serviceInfo = function (params) {
        return Axios.post("supplierclientapi/api/service_info", params);
    };
    ServiceInterfaceService.prototype.serviceSetting = function (params) {
        return Axios.post("supplierclientapi/api/service_set", params);
    };
    ServiceInterfaceService.prototype.groupBusinessShop = function (params) {
        return Axios.post("supplierclientapi/shop/group_business_shop", params);
    };
    ServiceInterfaceService.prototype.getBusiness = function (params) {
        return Axios.post("supplierclientapi/api/get_business", params);
    };
    ServiceInterfaceService.prototype.apply = function (params) {
        return Axios.post("supplierclientapi/api/apply", params);
    };
    ServiceInterfaceService.prototype.chargeInfo = function (params) {
        return Axios.post("supplierclientapi/api/charge_info", params);
    };
    ServiceInterfaceService.prototype.recharge = function (params) {
        return Axios.post("supplierclientapi/api/recharge", params);
    };
    ServiceInterfaceService.createInstance = function () {
        ServiceInterfaceService.getInstance();
    };
    ServiceInterfaceService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return ServiceInterfaceService;
}());
export default ServiceInterfaceService;
